module.exports = __webpack_public_path__ + "img/mask_layer_h5@2x.b6030bcc.png";